import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import DashboardLayout from '../../components/Layout/DashboardLayout';
import AlertMessage from '../../components/ui/AlertMessage';
import MetricCard from '../../components/ui/MetricCard';
import CheckinStep from '../../components/ui/CheckinStep';
import CreateTripIcon from '../../components/icons/CreateTripIcon';

const HomeUserScreen = () => {

    // Metrics data would typically come from an API call based on the user
    const metrics = []; // Placeholder

    const checkinSteps = [
        { id: 1, text: "Reunión agendada con el agente Checkin.", status: "completed" },
        { id: 2, text: "Revisión rutas con el agente.", status: "pending" },
    ];

    return (
        <DashboardLayout activeMenuItem="Inicio">
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3">
                <h1 className="h2 mb-0">¡Bienvenido viajero!</h1> {/* Adjusted mb-4 to mb-0 as per original main content */}
                <div className="btn-toolbar mb-2 mb-md-0">
                    <Link to="/user/questions/step1_1_clone_20_1750374165601_9w0xe" className="btn btn-success d-flex align-items-center">
                        <CreateTripIcon />
                        Crea tu viaje soñado
                    </Link>
                </div>
            </div>

            <AlertMessage
                message="Recuerda que para ver la información completa de tu viaje soñado debes agendar una reunión con el asesor Checkin"
            />

            <div className="row text-center my-4"> {/* Added my-4 for spacing */}
                {metrics.map(metric => (
                    <MetricCard key={metric.id} value={metric.value} text={metric.text} />
                ))}
            </div>

            <h3 className="mb-3">Tu ruta Checkin</h3>
            <p className="mb-4 text-muted">Tu información paso a paso de tu viaje soñado</p>

            <div className="list-group gap-3">
                {checkinSteps.map(step => (
                    <CheckinStep key={step.id} text={step.text} status={step.status} />
                ))}
            </div>
        </DashboardLayout>
    );
};

export default HomeUserScreen;